const ACCOUNT_TYPE_LABELS = {
  cash: "Cash Account",
  in_house_finance: "In-House Finance Account",
  local_lender_finance: "Outside Finance Account",
  wholesale: "Wholesale Account",
};

export const formatAccountTypeLabel = (accountType) => {
  if (accountType == null || accountType === "") return "-";
  const key = String(accountType).toLowerCase().trim();
  if (ACCOUNT_TYPE_LABELS[key]) return ACCOUNT_TYPE_LABELS[key];
  return String(accountType)
    .replace(/_/g, " ")
    .toLowerCase()
    .split(" ")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const formatAccountDescriptionDisplay = (description, accountType) => {
  if (accountType) return formatAccountTypeLabel(accountType);
  if (description == null || description === "") return "-";
  const key = String(description).toLowerCase().trim();
  if (ACCOUNT_TYPE_LABELS[key]) return ACCOUNT_TYPE_LABELS[key];
  return description;
};

export const getAccountDescriptionValue = (description, accountType) => {
  const display = formatAccountDescriptionDisplay(description, accountType);
  return display === "-" ? "" : display;
};
